<div *ngIf="this.isLoading" class="se-loader">
</div>
<div class=" p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input type="text" title={{labels.deviceMetadataSearchText|translate}} aria-label="search" class="input-globalsearch" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
      <button class="se-button cursorPointerHand" (click)="ExportDeviceMetadata()" >
        {{labels.btnExport | translate}}
      </button>
    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div class="rectangle-grid">
      <p-table #dt [columns]="selectedColumns" [value]="deviceMetadata" [paginator]="isPagination" [rows]="10"
         [sortOrder]="-1" [globalFilterFields]="['controllerTypeName','deviceType','addedBy','poli','mask','modbusSlaveId','release','pCH','locationCountry','firmwareVersion','dongleUId','name']">
        <ng-template pTemplate="caption">
          <div class="txt-align-left">
            <p-multiSelect [options]="filterCols" [(ngModel)]="selectedColumns" ngDefaultControl name="filterCols"
                           appendTo="body" class="multi-select-min-width" selectedItemsLabel="{0} {{labels.columnsSelected}}" optionLabel="header"
                           placeholder="{{labels.selectColumns}}"></p-multiSelect>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" [pSortableColumn]="'dongleUId'" class="width7per">
              {{labels.tableHeaderDongleUId | translate}}
              <p-sortIcon [field]="'dongleUId'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>

            </th>
            <th scope="col" [pSortableColumn]="'name'" class="width7per">
              {{labels.tableHeaderName | translate}}
              <p-sortIcon [field]="'name'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>

            <th scope="col" [pSortableColumn]="'lastConnectedOn'" class="width8per">
              {{labels.lastConnetedOn| translate}}
              <p-sortIcon [field]="'lastConnectedOn'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'addedBy'" class="width8per">
              {{labels.dgTblHeaderAddedBy| translate}}
              <p-sortIcon [field]="'addedBy'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'addedOn'" class="width8per">
              {{labels.addedOn| translate}}
              <p-sortIcon [field]="'addedOn'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'mask'" class="width5per">
              {{labels.mask| translate}}
              <p-sortIcon [field]="'mask'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'poli'" class="width5per">
              {{labels.poli| translate}}
              <p-sortIcon [field]="'poli'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'controllerTypeName'" class="width10per">
              {{labels.controllerTypeName| translate}}
              <p-sortIcon [field]="'controllerTypeName'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" [pSortableColumn]="'deviceType'" class="width7per">
              {{labels.deviceType| translate}}
              <p-sortIcon [field]="'deviceType'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>

            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'display': col.display}">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr class="rowHeight">
            <td class="rule-desc">{{rowData["dongleUId"]}}</td>
            <td class="rule-desc">{{rowData["name"]}}</td>
            <td class="rule-desc">{{(rowData["lastConnectedOn"] | date : 'dd-MM-yyyy HH:mm')|| '&nbsp;'}}</td>
            <td class="rule-desc">{{rowData["addedBy"] }}</td>
            <td class="rule-desc">{{(rowData["addedOn"]| date : 'dd-MM-yyyy HH:mm')|| '&nbsp;'}}</td>
            <td class="rule-desc">{{rowData["mask"]}}</td>
            <td class="rule-desc">{{rowData["poli"]}}</td>
            <td class="rule-desc">{{rowData["controllerTypeName"]}}</td>
            <td class="rule-desc">{{rowData["deviceType"]}}</td>
            <td class="rule-desc" *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
              <span title="{{rowData[col.field]}}">
                {{rowData[col.field]}}
              </span>
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noData">
            <td [attr.colspan]="columns.length">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
